module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('p', {
    staticClass: "note note--promo"
  }, [_vm._v("Er hebben zich nog geen leerlingen aangemeld voor deze klas. Leerlingen kunnen zich registreren via "), _c('strong', [_c('a', {
    attrs: {
      "href": '//' + _vm.registerLink
    }
  }, [_vm._v(_vm._s(_vm.registerLink))])]), _vm._v(" met code "), _c('strong', [_vm._v(_vm._s(_vm.group.code))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b0103e4","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/elements/EmptyGroupMessage.vue
// module id = LFug
// module chunks = 1